import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dirty hacks are everywhere",
  "description": "",
  "published": "2008-10-29T00:00:00.000Z",
  "redirect_from": ["/blog/dirty-hacks-are-everywhere/swizec/50"],
  "categories": "advice, commentary, funny, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Humans are most noted for their ability to think up solutions to problems quickly and efficiently - we in the technology industry call these solutions dirty hacks and try to avoid them at all cost, not because they were intrinsically bad, but because they are difficult to maintain.`}</p>
    <p>{`See when something becomes riddled with quick dirty hacks it may work, at the moment and it might even work in the next moment, but as soon as you start to make adjustments to change, try scaling the darn thing, or making any kind of modification it all just starts breaking apart. To an average human being this is most easily explained via real life dirty hacks we like to use every day.`}</p>
    <p>{`For example, you come home and find that you need to put something down but have no proper place to put it. So you look at the nearest semi-available flat surface - usually a chair of some sort. You put the thing there. Then you neatly forget about having to put it away and just leave it there; hey, it works, don't change it right? Then somebody comes over and you need the chair. Your solution must scale.`}</p>
    <p>{`So you put the thing that was occupying on the chair somewhere else, also usually an impromptu solution. Over time, with these kind of incrementally quick solutions you achieve something horrible. There is a flat surface somewhere in your home, or even just a floor corner, where a large pile of crap has built up over the week/month/year that is so high in fact you don't even know what's in it anymore ... and now you suddenly absolutely need that surface for something!`}</p>
    <p>{`Regardless of all this, I used a dirty hack last night when I wanted to read on my bed and still have tea available nice and easy. So I wedged it between the wall and the bed. By some strange coincidence I spilt not a drop.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      